export const faqsSection = () => {
  const $productFaqsSections = document.querySelectorAll(
    "section.product-faqs"
  );
  console.log("$productFaqsSections", $productFaqsSections);

  if ($productFaqsSections) {
    $productFaqsSections.forEach(($faqSection) => {
      const $faqs = $faqSection.querySelectorAll(".product-faqs__list .faq");
      $faqs.forEach(($faq) => {
        const $faqQuestion = $faq.querySelector(".faq__question");

        $faqQuestion.addEventListener("click", (event) => {
          event.preventDefault();

          const $currentFaqOpen = $faq.querySelector(
            ".faq__question-icon .faq__question-icon-open"
          );
          const $currentFaqClosed = $faq.querySelector(
            ".faq__question-icon .faq__question-icon-closed"
          );
          const $faqAnswer = $faq.querySelector(".faq__answer");
          $currentFaqOpen.classList.toggle("hidden");
          $currentFaqClosed.classList.toggle("hidden");
          $faqAnswer.classList.toggle("hidden");
        });
      });
    });
  }
};

export default faqsSection;
